var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup162718(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.9,
    height: 35.585,
    viewBox: "0 0 38.9 35.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162718",
    "data-name": "Group 162718",
    transform: "translate(9.392 22.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5356",
    "data-name": "Path 5356",
    d: "M.129.708a2.061,2.061,0,0,0,.9-.03c.045-.014.095-.045.09-.09A.109.109,0,0,0,1.1.542,2.789,2.789,0,0,1,.825.026.045.045,0,0,0,.808,0,.042.042,0,0,0,.779,0C.647.037.532.123.4.159A.537.537,0,0,1,.2.175C.135.168.054.119,0,.125.031.322.106.506.129.708Z",
    transform: "translate(8.181 2.667) rotate(-25)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    "data-name": "Path 5357",
    d: "M.329,1.024A1.567,1.567,0,0,0,.847.537.085.085,0,0,0,.861.5.087.087,0,0,0,.844.455,1.678,1.678,0,0,0,.423,0,1.229,1.229,0,0,0,.188.217C.139.269,0,.352,0,.432c0,.045.052.1.077.135s.064.1.094.149A1.768,1.768,0,0,1,.329,1.024Z",
    transform: "translate(12.787 -0.381) rotate(-25)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M3.06.99a.2.2,0,0,1-.036.131.177.177,0,0,1-.076.045c-.419.15-.9-.037-1.321.111-.086.03-.167.074-.253.1a1.379,1.379,0,0,1-.316.056c-.148.014-.3.023-.444.027a1.068,1.068,0,0,1-.335-.029.4.4,0,0,1-.257-.2.2.2,0,0,1-.013-.145A.156.156,0,0,1,.036,1.04a.4.4,0,0,1,.1-.08l.154-.1A1.034,1.034,0,0,1,.522.737C.583.717.647.708.709.692a1.272,1.272,0,0,0,.535-.4l.21-.224A.211.211,0,0,1,1.527.01.2.2,0,0,1,1.617,0a1.208,1.208,0,0,1,.571.191.739.739,0,0,0,.141.083A.5.5,0,0,0,2.723.228c.054-.029.042-.045.065-.1s.078-.084.126-.037a.133.133,0,0,1,.03.057,1.6,1.6,0,0,1,.028.466A.2.2,0,0,0,2.98.688a.409.409,0,0,0,.041.067l.009.017A.459.459,0,0,1,3.06.99Z",
    transform: "translate(6.725 3.702) rotate(-25)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M3.06.219A.2.2,0,0,1,3.024.35.177.177,0,0,1,2.948.4c-.419.15-.9-.037-1.321.111-.086.03-.167.074-.253.1a1.378,1.378,0,0,1-.316.056C.91.679.761.688.613.692A1.068,1.068,0,0,1,.278.663a.4.4,0,0,1-.257-.2A.2.2,0,0,1,.008.314.156.156,0,0,1,.036.269C.06.32.078.388.093.412a.293.293,0,0,0,.2.141A.487.487,0,0,0,.47.531,9.1,9.1,0,0,0,1.617.293,2.653,2.653,0,0,1,1.993.149,2.953,2.953,0,0,1,2.4.116C2.613.1,2.82.034,3.031,0A.459.459,0,0,1,3.06.219Z",
    transform: "translate(7.05 4.401) rotate(-25)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    "data-name": "Path 5360",
    d: "M2.371.723a.761.761,0,0,1-.231.412,2.694,2.694,0,0,0-.324.354,2.85,2.85,0,0,1-.3.511.817.817,0,0,1-.181.129,1.259,1.259,0,0,1-.233.107,1.735,1.735,0,0,1-.657.036.591.591,0,0,1-.209-.04.627.627,0,0,1-.087-.053.414.414,0,0,1-.135-.135A.135.135,0,0,1,0,1.944a.231.231,0,0,1,.063-.1,1.491,1.491,0,0,1,.159-.143.951.951,0,0,0,.207-.181.584.584,0,0,0,.08-.181A1.6,1.6,0,0,0,.571,1,1.1,1.1,0,0,1,.595.767C.628.648.717.542.707.418a.087.087,0,0,1,0-.053A.073.073,0,0,1,.753.34.736.736,0,0,1,.969.29a.251.251,0,0,1,.2.079c.031.037.051.09.1.1a.153.153,0,0,0,.069,0,.575.575,0,0,0,.316-.1A.394.394,0,0,0,1.781.091c0-.041-.019-.084.045-.09.048-.006.086.045.11.077a1.07,1.07,0,0,1,.211.385.113.113,0,0,1,.04-.008.175.175,0,0,1,.144.074A.287.287,0,0,1,2.371.723Z",
    transform: "translate(11.92 0.325) rotate(-25)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    "data-name": "Path 5361",
    d: "M2.354.275a.761.761,0,0,1-.231.412,2.694,2.694,0,0,0-.324.354,2.852,2.852,0,0,1-.3.511.818.818,0,0,1-.181.129,1.26,1.26,0,0,1-.233.107,1.735,1.735,0,0,1-.657.036.591.591,0,0,1-.209-.04A.627.627,0,0,1,.135,1.73.414.414,0,0,1,0,1.595a.33.33,0,0,1,.135-.033c.1.005.169.1.262.126.133.04.266-.054.4-.086.088-.021.181-.015.268-.045a.662.662,0,0,0,.2-.12,1.009,1.009,0,0,0,.212-.2A1.312,1.312,0,0,0,1.6.985,3.544,3.544,0,0,1,1.852.5.339.339,0,0,1,1.9.438a.709.709,0,0,1,.069-.05A.525.525,0,0,0,2.131.1.509.509,0,0,1,2.167,0a.175.175,0,0,1,.144.074A.287.287,0,0,1,2.354.275Z",
    transform: "translate(12.125 0.723) rotate(-25)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M177.723,355.037v-.561a1.557,1.557,0,0,0-1.557-1.557H154.017a1.557,1.557,0,0,0-1.557,1.557v1.034Z",
    transform: "translate(-156.643 -359.944)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M0,3.458S-.062,7.38.634,8.671s.993,6.905.993,6.905,7.29.754,12.37-.9,15.89-2.335,15.89-2.335L28.066.059s-9-.577-14.119,1.865S0,3.458,0,3.458Z",
    transform: "translate(-4.235 -4.896) rotate(-25)",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M0,3.458S-.062,7.38.634,8.671s.993,6.905.993,6.905,7.29.754,12.37-.9,15.89-2.335,15.89-2.335L28.066.059s-9-.577-14.119,1.865S0,3.458,0,3.458Z",
    transform: "translate(-4.235 -4.896) rotate(-25)",
    fill: "#d3d3d3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M.045,4.023S-.183,7.26.389,8.294s.6,5.651.6,5.651,6.561.3,11.228-1.284S26.69,10.041,26.69,10.041L25.576,0S17.461-.083,12.725,2.153.045,4.023.045,4.023Z",
    transform: "translate(-2.445 -4.774) rotate(-25)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M25.668,0S16.925,2.213,12.8,6.108,0,11.847,0,11.847,1.143,15.6,2.2,16.614s3.063,6.268,3.063,6.268,7.17-1.52,11.5-4.658,14.408-7.1,14.408-7.1Z",
    transform: "translate(-9.036 -9.191) rotate(-25)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M0,11.846S1.143,15.6,2.2,16.614s3.063,6.267,3.063,6.267,7.171-1.52,11.5-4.657,14.408-7.1,14.408-7.1L25.668,0S16.925,2.213,12.8,6.108,0,11.846,0,11.846Z",
    transform: "translate(-9.392 -9.644) rotate(-25)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M0,11.846S1.143,15.6,2.2,16.614s3.063,6.267,3.063,6.267,7.171-1.52,11.5-4.657,14.408-7.1,14.408-7.1L25.668,0S16.925,2.213,12.8,6.108,0,11.846,0,11.846Z",
    transform: "translate(-9.392 -9.644) rotate(-25)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M0,11.664s.776,3.151,1.638,3.959,2.3,5.193,2.3,5.193,6.337-1.724,10.292-4.668,12.973-6.93,12.973-6.93L23.065,0s-7.749,2.41-11.57,5.992S0,11.664,0,11.664Z",
    transform: "translate(-7.159 -9.526) rotate(-25)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_691",
    "data-name": "Ellipse 691",
    cx: 1.703,
    cy: 3.653,
    rx: 1.703,
    ry: 3.653,
    transform: "translate(4.947 -5.943) rotate(-50)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M178.35,378.791V394.37A1.347,1.347,0,0,1,177,395.717H153.837a1.347,1.347,0,0,1-1.347-1.347V377.22a2.378,2.378,0,0,0,1.347.226H177A1.348,1.348,0,0,1,178.35,378.791Z",
    transform: "translate(-156.672 -383.146)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M178.35,383.171V398.75A1.348,1.348,0,0,1,177,400.1H153.837a1.347,1.347,0,0,1-1.347-1.347V381.6a2.386,2.386,0,0,0,1.347.226H177A1.348,1.348,0,0,1,178.35,383.171Z",
    transform: "translate(-156.672 -387.328)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M568.843,543.935v4.982h-4.832a2.491,2.491,0,1,1,0-4.982Z",
    transform: "translate(-547.231 -542.333)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M570.3,541v4.983h-4.832a2.491,2.491,0,1,1,0-4.982Z",
    transform: "translate(-548.625 -539.53)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_692",
    "data-name": "Ellipse 692",
    cx: 0.971,
    cy: 0.971,
    r: 0.971,
    transform: "translate(16.107 3.122)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_693",
    "data-name": "Ellipse 693",
    cx: 0.971,
    cy: 0.971,
    r: 0.971,
    transform: "translate(16.173 2.99)",
    fill: "#6f6f6f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup162718);
export default __webpack_public_path__ + "static/media/Group-162718.88d98eb840cfa67b370c04c353f3c7e6.svg";
export { ForwardRef as ReactComponent };